import React from 'react'
import styles from './announcement.styl'
import PropTypes from 'prop-types'

const Announcement = ({ children, className }) => (
  <div className={`${styles.wrap} ${className}`}>
    {children}
  </div>
)

Announcement.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
}

export default Announcement
